import { Alert, Stack } from '@mui/material'
import HeatStressOverview from './heatStress/HeatStressOverview'
import HeatStressTrends from './heatStress/HeatStressTrends'
import type { CanonicalPeriod, EmissionTier } from '../common'

type PropertyHeatStressProps = {
  propertyId: number
  emissionTier: EmissionTier
  selectedPeriod: CanonicalPeriod
}

const PropertyHeatStress = ({ propertyId, emissionTier, selectedPeriod }: PropertyHeatStressProps) => {
  if (!propertyId) {
    return <Alert severity="info">Select a property to view heat stress metrics.</Alert>
  }

  return (
    <Stack spacing={4}>
      <HeatStressOverview propertyId={propertyId} emissionTier={emissionTier} selectedPeriod={selectedPeriod} />
      <HeatStressTrends propertyId={propertyId} emissionTier={emissionTier} />
    </Stack>
  )
}

export default PropertyHeatStress
